import Konva from 'konva';

function stringToArray(string: string) {
  return Array.from(string);
}

const CENTER = 'center',
  JUSTIFY = 'justify',
  LEFT = 'left',
  BOTTOM = 'bottom',
  MIDDLE = 'middle',
  RIGHT = 'right';

export default function (context: Konva.Context & CanvasRenderingContext2D) {
  const textArr = this.textArr,
    textArrLen = textArr.length;
  if (!this.text()) {
    return;
  }
  let alignY = 0;
  const padding = this.padding(),
    fontSize = this.fontSize(),
    lineHeightPx = this.lineHeight() * fontSize,
    verticalAlign = this.verticalAlign(),
    align = this.align(),
    totalWidth = this.getWidth(),
    letterSpacing = this.letterSpacing(),
    fill = this.fill(),
    textDecoration = this.textDecoration(),
    shouldUnderline = textDecoration.indexOf('underline') !== -1,
    shouldLineThrough = textDecoration.indexOf('line-through') !== -1;
  const translateY = 0;
  context.setAttr('font', this._getContextFont());
  context.setAttr('textAlign', LEFT);
  if (verticalAlign === MIDDLE) {
    alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
  } else if (verticalAlign === BOTTOM) {
    alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
  }
  context.translate(padding, alignY + padding);
  const { actualBoundingBoxAscent } = context.measureText(this.text());
  for (let n = 0; n < textArrLen; n++) {
    let lineTranslateX = 0;
    const lineTranslateY = 0;
    const obj = textArr[n],
      text = obj.text,
      width = obj.width,
      lastLine = n !== textArrLen - 1;
    let spacesNumber, oneWord, lineWidth;
    context.save();
    if (align === RIGHT) {
      lineTranslateX += totalWidth - width - padding * 2;
    } else if (align === CENTER) {
      lineTranslateX += (totalWidth - width - padding * 2) / 2;
    }
    if (shouldUnderline) {
      const underlineY = n * lineHeightPx + fontSize / 8 + actualBoundingBoxAscent;
      context.save();
      context.beginPath();
      context.moveTo(lineTranslateX, underlineY);
      spacesNumber = text.split(' ').length - 1;
      oneWord = spacesNumber === 0;
      lineWidth = align === JUSTIFY && lastLine && !oneWord ? totalWidth - padding * 2 : width;
      context.lineTo(lineTranslateX + Math.round(lineWidth), underlineY);
      context.lineWidth = Math.floor(fontSize / 15);
      context.strokeStyle = fill;
      context.stroke();
      context.restore();
    }
    if (shouldLineThrough) {
      context.save();
      context.beginPath();
      context.moveTo(lineTranslateX, translateY + lineTranslateY);
      spacesNumber = text.split(' ').length - 1;
      oneWord = spacesNumber === 0;
      lineWidth = align === JUSTIFY && lastLine && !oneWord ? totalWidth - padding * 2 : width;
      context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY);
      context.lineWidth = fontSize / 15;
      context.strokeStyle = fill;
      context.stroke();
      context.restore();
    }
    if (letterSpacing !== 0 || align === JUSTIFY) {
      spacesNumber = text.split(' ').length - 1;
      const array = stringToArray(text);
      for (let li = 0; li < array.length; li++) {
        const letter = array[li];
        if (letter === ' ' && n !== textArrLen - 1 && align === JUSTIFY) {
          lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
        }
        this._partialTextX = lineTranslateX;
        this._partialTextY = actualBoundingBoxAscent + n * lineHeightPx;
        this._partialText = letter;
        context.fillStrokeShape(this);
        lineTranslateX += this.measureSize(letter).width + letterSpacing;
      }
    } else {
      this._partialTextX = lineTranslateX;
      this._partialTextY = actualBoundingBoxAscent + n * lineHeightPx;
      this._partialText = text;
      context.fillStrokeShape(this);
    }
    context.restore();
  }
}
